import React, { useState, useRef, useMemo, useEffect, Fragment } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import Slider from 'react-slick'
import { withWindowSizeListener } from 'react-window-size-listener'
import '../styles/components/Carousel.css'
import MenuButton from '../components/MenuButton'
import { FaCommentAlt } from 'react-icons/fa'

const Carousel = props => {
  const sliderHeight = useMemo(() => props.windowSize.windowHeight - 75 - 16 - 50 - 15, [props.windowSize.windowHeight])
  const settings = useMemo(() => ({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: 0,
    useTransform: true,
    arrows: false,
    className: 'imagecarousel-slider',
    afterChange: page => {
      setPage(page)
      scrollToMiniature(page)
    }
  }), [])

  const [page, setPage] = useState(props.initialPhoto || 0)

  const miniaturesRef = useRef(null)

  const scrollToMiniature = index => {
    const left = index === 0 ? 0 : 24 + index * 60 + ((index - 1) * 12)

    miniaturesRef && miniaturesRef.current && miniaturesRef.current.scroll({
      left,
      behavior: 'smooth'
    })
  }

  let sliderRef

  useEffect(() => {
    const slider = document.getElementsByClassName('imagecarousel-slider')[0]
    if (sliderHeight > 0) {
      slider.style.height = `${sliderHeight}px`
      slider.style.width = '100%'
    }

    scrollToMiniature(props.initialPhoto)
  }, [props.windowSize.windowHeight])

  useEffect(() => {
    if (props.currentPage){
      props.currentPage(page)
    }
  }, [page])

  const setCommentFeedbackPopup = comment => {
    props.setCommentFeedbackPopup(comment)
  }

  return (
    <div className='carousel-container'>
      <div className='imagecarousel-screen-carousel'>
        <div className='imagecarousel-slider-container'>
          <Slider
            ref={function (ref) {
              sliderRef = ref
            }} {...settings} initialSlide={props.initialPhoto || 0}>
            {props.photos.map(photo => {
              return (
                <div key={photo.image} className='carousel-child-element'>
                  <div style={{
                    height: sliderHeight,
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 12
                  }}>
                    <img src={photo.image} alt={photo.image}
                      className='imagecarousel-image' />
                    {photo.text ? (
                      <div className='imagecarousel-text'>
                        {photo.text}
                      </div>
                    ) : false}
                    {(photo.textFeedback && photo.textFeedback.length > 0) ? (
                      <Fragment>
                        {!photo.text && <div style={{height: 8}} />}
                        <MenuButton className={'imagecarousel-button'} backgroundColor='#7BA7CEB3' Icon={FaCommentAlt} onClick={() => setCommentFeedbackPopup(photo.textFeedback)}>Mostrar Comentario</MenuButton>
                        <div style={{height: 8}} />
                      </Fragment>
                    ) : false}
                  </div>
                </div>
              )
            })}
          </Slider>
          <button className='imagecarousel-prev' onClick={() => {
            const prevPage = page - 1 % props.photos.length
            setPage(prevPage)
            scrollToMiniature(prevPage)
            sliderRef.slickPrev()
          }}>
            <FaChevronLeft color='var(--primary)' size={16} />
          </button>
          <button className='imagecarousel-next' onClick={() => {
            const nextPage = page + 1 % props.photos.length
            setPage(nextPage)
            scrollToMiniature(nextPage)
            sliderRef.slickNext()
          }}>
            <FaChevronRight color='var(--primary)' size={16} />
          </button>
        </div>
      </div>
      <div className='imagecarousel-screen-miniatures' ref={miniaturesRef}>
        {props.photos.map((photo, index) => {
          return (
            <div key={photo.image} onClick={() => {
              sliderRef.slickGoTo(index)
              setPage(index)
              scrollToMiniature(index)
            }} className={`imagecarousel-miniatures-item${page === index ? ' selected-miniature' : ''}`}>
              <img src={photo.image} alt={photo.image} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default withWindowSizeListener(Carousel)



// WEBPACK FOOTER //
// ./src/components/Carousel.js